import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BsCheckCircle } from "react-icons/bs";

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 5000);
  });

  return (
    <section className="min-h-[100vh] py-10 flex flex-col justify-center items-center gap-10 bg-primary">
      <div>
        <BsCheckCircle className="text-[200px] text-green-500" />
      </div>
      <div className="flex flex-col items-center justify-center">
        <h1 className="sm:text-[72px] text-[48px] font-bold tracking-wide text-textPrimary text-center sm:leading-[80px] leading-[52px]">
          धन्यवाद !
        </h1>
        <h3 className="sm:text-[40px] text-[32px] text-textPrimary text-center">
          प्रतिकृया का लागि धन्यवाद
        </h3>
      </div>
    </section>
  );
};

export default ThankYou;
